

import { EncryptService } from './../../../core/services/encrypt.service';
import { AuthService } from './../../../core/services/auth.service';

import { Component, OnInit} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { passwordStrength } from 'check-password-strength';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  newPasswordAgain: string = '';
  newPassword: string = '';
  password: string = '';
  email: any;
  form: FormGroup = new FormGroup({});
  formSubmitAttempt = false;
  hide = true;
  submitData = {
    emailId: '',
    password: '',
    newPassword: ''
  };

  showStrength = false;
  color: string = "red";
  passwordStrength: string = "Weak";
  samePwd = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService,
    private encryptService: EncryptService
  ) {
  }

  ngOnInit() {
    this.email = sessionStorage.getItem('email');
    if (!this.email) {
      this.email = this.route.snapshot.paramMap.get('id');
    }
    this.form = this.fb.group({
      newPassword: ['', Validators.required],
      newPasswordAgain: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  isFieldInvalid(field: string) {
    return (
      (!this.form.controls[field].valid && this.form.controls[field].touched) ||
      (this.form.controls[field].untouched && this.formSubmitAttempt)
    );
  }

  onSubmit() {
    if (this.form.valid && this.samePwd && this.passwordStrength.toLowerCase() === 'strong') {
      this.submitData.emailId = this.encryptService.generateEncryption(this.email);
      this.submitData.password = this.encryptService.generateEncryption(this.password);
      this.submitData.newPassword = this.encryptService.generateEncryption(this.newPassword);
      Swal.showLoading();
      this.authService.passwordChange(this.submitData).subscribe(
        (data1: any) => {
          Swal.close();
          if (data1.status === 200) {
            if (sessionStorage.getItem('id')) {
              Swal.fire(
                'Password Updated successfully!',
                'You will be logged out, please relogin with your new password.',
                'success'
              ).then(() => {
                this.authService.logoutService();
              });
            } else {
              Swal.fire('Password Updated successfully!', 'Please login with your new password', 'success');
              this.router.navigate([`./login`]);
            }
          }
        },
        (error: any) => {
          Swal.close();
          if (error.toLowerCase().includes('password is locked')) {
            Swal.fire(
              '',
              error ? error : 'Something went wrong! please try again later',
              'error'
            ).then(() => {
              this.authService.logoutService();
            });
          }
          else {
            Swal.fire('', error ? error : 'Somthing went wrong', 'error');
          }
        }
      );
    }
    else {
      if (this.form.invalid) {
       Swal.fire('Please fill all the required fields', '', 'error');
      }
      else if (!this.samePwd) {
       Swal.fire('Password and Confirm Password don’t match', '', 'error');
      }
      else if (this.passwordStrength.toLowerCase() !== 'strong') {
       Swal.fire('Please provide strong password', '', 'error');
      }
    }
  }

  checkStrength = (event: any) => {
    if (event.target.value) {
      this.showStrength = true;
      this.passwordStrength = passwordStrength(event.target.value).value;
      if (this.passwordStrength.toLowerCase() === "weak") this.color = "red";
      if (this.passwordStrength.toLowerCase() === "medium") this.color = "orange";
      if (this.passwordStrength.toLowerCase() === "strong") this.color = "green";
    }
    else {
      this.showStrength = true;
      this.passwordStrength = "Weak";
      this.color = "red";
    }
  }

  checkPassword = (event: any) => {
    if (this.form.controls['newPassword'].value === this.form.controls['newPasswordAgain'].value) return this.samePwd = true;
    return this.samePwd = false;
  }

}
